import { render, staticRenderFns } from "./ForceLogoutConfirmation.vue?vue&type=template&id=2e946872&"
import script from "./ForceLogoutConfirmation.vue?vue&type=script&lang=js&"
export * from "./ForceLogoutConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports